<template>
  <div>
    <button type="button" class="btn btn-sm btn-outline-primary mr-1" data-toggle="modal" data-target=".modal-new-graduate">
      <font-awesome :icon="['far', 'plus']" class="far mr-2"/> Add Graduate
    </button>

    <button type="button" class="btn btn-sm btn-outline-primary mr-1" data-toggle="modal" data-target=".modal-import-export-draw">
      <font-awesome :icon="['far', 'file-import']" class="far mr-2"/> Import/Export Graduates
    </button>

    <ladda-button v-if="$userIsAdmin" :click="handleActivateGraduates" class="btn btn-sm btn-outline-success float-right">
      <font-awesome :icon="['far', 'check']" class="mr-2"/> Activate Accounts
    </ladda-button>

    <div class="decorative-divider"></div>

    <h3>Filter</h3>

    <div class="row">
      <div class="col-lg-7 col-xl-8">
        <div class="form-group">
          <label class="control-label">Graduate Name / Email / GEN</label>
          <input v-model="filters.search" type="text" class="form-control">
        </div><!-- /.form-group -->
      </div>
      <div class="col-lg-5 col-xl-4">
        <div class="form-group">
          <label class="control-label">Show</label>
          <multiselect
            v-model="showOptionSelected"
            label="text"
            :options="showOptions"
            :allow-empty="false"
            :searchable="false"
            :show-labels="false"/>
        </div><!-- /.form-group -->
      </div>
    </div><!-- /.row -->

    <div class="decorative-divider"></div>

    <div class="card">
      <ul class="list-data">
        <li class="data-heading d-none d-lg-block">
          <div class="row">
            <div class="col-12 col-lg-7">
              <p>Graduate</p>
            </div>

            <div class="col-6 col-lg-1 text-center">
              <p data-toggle="tooltip" data-placement="top" title="Placement 1 Assignment">
                P1
                <span class="sr-only">placement 1 agency assignment</span>
              </p>
            </div>

            <div class="col-6 col-lg-1 text-center">
              <p data-toggle="tooltip" data-placement="top" title="Placement 2 Assignment">
                P2
                <span class="sr-only">placement 2 agency assignment</span>
              </p>
            </div>

            <div class="col-6 col-lg-1 text-center">
              <p data-toggle="tooltip" data-placement="top" title="Initial capability assessment data">
                <font-awesome :icon="['far', 'ballot-check']"/>
                <span class="sr-only">Initial capability assessment data</span>
              </p>
            </div>

            <div class="col-6 col-lg-1 text-center">
              <p data-toggle="tooltip" data-placement="top" title="User account activation status">
                <font-awesome :icon="['far', 'user']"/>
                <span class="sr-only">user account activation</span>
              </p>
            </div>
          </div>
          <!-- /.row -->
        </li>

        <loading-spinner v-if="fetching"/>

        <no-results v-else-if="noGraduates">
          No graduates found.
        </no-results>

        <graduates-list-item v-for="graduate in graduates" :graduate="graduate" :key="graduate.item"/>
      </ul><!-- /.list-data -->

      <lazy-loading
        :loading="$loading"
        :reached-bottom="handleGetNextGraduatesCallback"
        ref="lazy">
        <loading-spinner slot="loading"/>
        <span slot="finished"></span>
      </lazy-loading>
    </div><!-- /.card -->

    <programs-single-graduates-admin-import-export-draw :program="program" @imported="refreshGraduates" />

    <portal to="modals">
      <add-graduate-modal/>
    </portal>
  </div>
</template>
<script>
import { programComputed, programGraduateComputed, programGraduateMethods } from 'vx/helpers'
import { appliesFilters } from 'mixins'
import GraduatesListItem from './ProgramsSingleGraduatesAdminListItem'
import AddGraduateModal from './AddGraduateModal'
import Multiselect from 'vue-multiselect'
import ProgramsSingleGraduatesAdminImportExportDraw from './ProgramsSingleGraduatesAdminImportExportDraw.vue'

export default {
  mixins: [appliesFilters],

  components: {
    ProgramsSingleGraduatesAdminImportExportDraw,
    GraduatesListItem,
    AddGraduateModal,
    Multiselect
  },

  data () {
    return {
      fetching: false,
      filters: {
        search: null,
        missing: 'all'
      },
      showOptions: [
        {
          value: 'all',
          text: 'Show All'
        },
        {
          value: 'first',
          text: 'Unassigned Placement 1'
        },
        {
          value: 'second',
          text: 'Unassigned Placement 2'
        },
        {
          value: 'capability',
          text: 'Missing Capability Data'
        },
        {
          value: 'disabled',
          text: 'User account not active'
        }
      ]
    }
  },

  computed: {
    ...programComputed,
    ...programGraduateComputed,

    showOptionSelected: {
      get () {
        return this.showOptions.find(option => option.value === this.filters.missing)
      },

      set (option) {
        this.filters.missing = option.value
      }
    },

    noGraduates () {
      return this.graduates.length === 0
    }
  },

  watch: {
    queryParams: {
      async handler (params) {
        this.fetching = true

        await this.getGraduates({ params })

        this.fetching = false

        this.$nextTick(() => {
          if (this.$refs.lazy) {
            this.$refs.lazy.$emit('reset')
          }
        })
      },
      immediate: true
    }
  },

  beforeDestroy () {
    this.resetGraduates()
  },

  methods: {
    ...programGraduateMethods,

    async refreshGraduates () {
      await this.getGraduates({ params: this.queryParams })
    },

    async handleGetNextGraduatesCallback () {
      await this.getGraduates({ params: this.queryParams, next: true })

      this.$refs.lazy.$emit('reset')
    },

    async handleActivateGraduates () {
      try {
        await this.activateGraduates()
        this.getGraduates({ params: this.queryParams })
      } catch (error) {
        this.$noty.error('Unable to activate graduates')
      }
    }
  }
}
</script>
